module.exports = __webpack_public_path__ + "img/2-1_06.069fc742.jpg";